/*
 Stan strony z ofertą / rezerwacjami
 
 Redux (z użyciem redux-compact)
 https://github.com/maciekwawro/redux-compact

 */
import {
  applyMiddleware, compose,
  createStore, Store
} from 'redux';

import logger from 'redux-logger';

import thunk from 'redux-thunk';

import { definition, create, combine, StateOf } from 'redux-compact';

import { setValueReducer } from 'redux-compact/plugins';
//import { EntranceType } from '../app/Browse';

import i18n from '../cfg/i18n'
import { OfferTableRow, PDFData, Kontakt1, Info, Font, AsortMenuWiersz, AsortGrupyWiersz, WWWSprzedazInfo, AsortWWWMenuNagl, UserData, PrefiksPl } from '../api';
import { sendFcmErrorLog } from '../app/common/helpers';

import { MapData } from 'app/map_new/MapContainer';

enum PanelState {
  psBrowse,
  psDetails,
  psUser,
  psUser2,
  psUser3,
  psUser4,
  psUser5,
  psUser6,
  psUser7,
  psCalendar,
  psReservPending,
  psEndWindow,
  psLogin
  /*  psSelect,
    psReservation,
    psCommit,
    psPayment*/
}

export enum DisplayWindow {
  Loading,
  Main,
  Map,
  History
}

export type Navigator = {
  page: number;
  perPage: number;
  filter: string;
  order: string;
}

export type FcmMessage = {
  text: string;
  type: number;
}

// export type ResBasketItem =
//   {
//     grupa_id: string,
//     grupa_lp: string,
//     stawka_vat: string,
//     mag_id: string,
//     asort_id: string,
//     asort_nazwa: string,
//     cena: string,
//     kolejnosc: string
//   };

// export type ResBasket = ResBasketItem[];

export type Contact = {
  email: string,
  phone: string,
  fax: string,
  address: string,
  gps: string
}

export type Values = {
  address: string,
  email: string;
  phone: number,
  NIP: string,
  Date: string,
}

//export type pdfDataClass ={
//price : number,
//regular : string,
//discounted : string,
//}

export interface IPageState {
  displayWindow: DisplayWindow; //widok strony głównej
  displayMenu: number; // widok środkowego panelu
  state: PanelState; // stan przeglądania
  dateFrom: string; // od dnia
  dateTo: string; // do dnia
  basket: AsortGrupyWiersz[],//ResBasket; // koszyk rezerwacji
  navigator: Navigator; // nawigator - na przyszłość
  selectedRoom: string; // id. aktualnie wybanego pokoju
  lang: string; // język
  contact: Info;
  mapaGps: string;
  normalTicketsQuantity: number;
  massageTicketsQuantity: number;
  nightTicketsQuantity: number;
  giftQuantity: number;
  //entranceTypes : EntranceType[];
  //entranceType : EntranceType,
  reservationId: number,
  pdfData: PDFData[],
  downloadedPdf: boolean,
  searchCount: number,
  editCount: number,
  wejscieIlosc: number
  downloadCount: number;
  sold: number;
  control: number;
  entered: number;
  columns: number; //liczda wyświetlanych dni
  //display: number;
  displayRight: number;
  karnetNumber: number;
  freePlaces: number;
  passFailureCount: number,
  keepersQuantity: number;
  acceptCount: number,
  initialValues: Values,
  rememberValues: boolean,
  searchSessionCount: number,
  selectedReport: string,
  cancelCount: number,
  paymentMethod: number,
  textTheme: number,
  fonts: Font[],

  menuItems: AsortWWWMenuNagl[],
  asortHeaders: AsortMenuWiersz[],
  asort: AsortGrupyWiersz[][],
  selectedMenuItem: number,
  minItems: number,
  info: WWWSprzedazInfo & { ip: string },
  dialogEnd: number,
  dialogSms: number,
  kontakt: Kontakt1[],
  secondaryLight: string;
  langPhone: any;
  fcmLogMessage: FcmMessage[];
  bCpyToCart: boolean;

  userData: UserData;
  dostawaDataDzien: string;
  refresh: number;

  map: MapData,
  
  czarnaLista: any[],
  prefiksyPl: PrefiksPl[],
  priorytet: number,
  priorytetMin: number,
  priorytetMax: number,
  asortymentowWGrupie: number,
  resetBoldy: number,
};

function tomorrow(): Date {
  let d = new Date();
  d.setDate(d.getDate() + 1);
  return d;
};
function afterTomorrow(): Date {
  let d = new Date();
  d.setDate(d.getDate() + 2);
  return d;
};

function nextDay(sDate: string): string {
  let dt: Date = new Date(sDate);
  dt.setDate(dt.getDate() + 1);
  dt.setMonth(dt.getMonth());
  dt.setFullYear(dt.getFullYear());
  return dt.toISOString().substring(0, 10);
};

//type Dispatch = ReduxDispatch<IPageState>;

function setInitialValuesFromCookies(): Values {
  let adress = ''
  let email = ''
  let phone = 0
  let nip = ''

  let cookies = localStorage.getItem('cookies_zaakceptowane')
  if(cookies === "true"){
    let a = localStorage.getItem('adres');
    if(a) adress = a
    let p = localStorage.getItem('numer_telefonu');
    if(p) {
      p = p.split(" ").join("")
      phone = Number(p)
    }
    let n = localStorage.getItem('nip');
    if(n) nip = n
    let e = localStorage.getItem('email');
    if(e) email = e
  }

  return {
    address: adress,
    email: email,
    phone: phone,
    NIP: nip,
    Date: ""
  }
}

const pageState = definition<IPageState>()
  .setDefault(
    {
      displayWindow: DisplayWindow.Loading,
      displayMenu: 1,
      state: PanelState.psBrowse,
      dateFrom: new Date().toISOString().substring(0, 10),
      /*      dateTo :  (
              new Date().getDate() + 1
            ).toString().substring(0, 10), */
      dateTo: new Date().toISOString().substring(0, 10),
      pdfData: [],
      //      reservations : [],
      basket: [],
      navigator: {
        page: 1,
        perPage: 5,
        filter: '',
        order: ''
      },
      selectedRoom: ' - nic nie wybrano - ',
      lang: 'pl',
      contact: new Info(),
      mapaGps: "",
      normalTicketsQuantity: 1,
      massageTicketsQuantity: 0,
      nightTicketsQuantity: 1,
      giftQuantity: 1,
      reservationId: 0,
      downloadedPdf: false,
      searchCount: 0,
      editCount: 0,
      downloadCount: 0,
      sold: 0,
      control: 0,
      entered: 0,
      columns: 14,
      //display: 1,
      displayRight: 0,
      karnetNumber: 0,
      wejscieIlosc: 0,
      freePlaces: 0,
      passFailureCount: 0,
      keepersQuantity: 1,
      acceptCount: 0,
      initialValues: setInitialValuesFromCookies(),
      //initialValues: { address: '', phone: 0, NIP: '',},
      rememberValues: false,
      searchSessionCount: 0,
      selectedReport: "0",
      cancelCount: 0,
      paymentMethod: -1,
      textTheme: 0,
      fonts: [],

      menuItems: [],
      asortHeaders: [],
      asort: [],
      selectedMenuItem: 0,
      minItems: 1,
      info: { ...new WWWSprzedazInfo(), ip: '---' },
      dialogEnd: 0,
      dialogSms: 0,
      kontakt: [],
      secondaryLight: 'rgb(232, 240, 254)',
      langPhone: { flag: 'pl', prefix: "48 " },
      fcmLogMessage: [],
      bCpyToCart: false,

      userData: new UserData(),
      dostawaDataDzien: '',
      refresh: 0,

      map: new MapData(),
      czarnaLista: [],
      prefiksyPl: [],
      priorytet: 1,
      priorytetMin: 1,
      priorytetMax: 1,
      asortymentowWGrupie: 0,
      resetBoldy: 0
    })
  .addReducers({
    setUser: (pageState: IPageState) => ({ ...pageState, completed: true }),
    setDisplayWindow: (pageState: IPageState, newDisplay: DisplayWindow) =>
    ({ ...pageState, displayWindow: newDisplay }),
    setPanelState: (pageState: IPageState, newState: PanelState) =>
      ({ ...pageState, state: newState }),
    restart: (pageState: IPageState) =>
      ({ ...pageState, basket: [], state: PanelState.psBrowse }),
    setDateFrom: (pageState: IPageState, date: string, mode: number = 0) => {
      if (date == pageState.dateFrom) return pageState
      else {
        //let date2 : string = nextDay(date);
        if (mode == 0) {
          return ({
            ...pageState, basket: [], dateFrom: date,
            dateTo: date
          })
        } else {
          return ({
            ...pageState, basket: [], dateFrom: date,
            dateTo: date, displayRight: pageState.displayRight + 1
          })
        }

      }
    },
    setDateTo: (pageState: IPageState, date: string) => {
      if (date == pageState.dateTo) return pageState
      else return ({ ...pageState, basket: [], dateTo: date })
    },
    setContact: (pageState: IPageState, contact: Info) =>
      ({ ...pageState, contact: contact }),
    setMapaGps: (pageState: IPageState, gps: string) =>
      ({ ...pageState, mapaGps: gps }),  
    setColumns: (pageState: IPageState, col: number) =>
      ({ ...pageState, columns: col }),
    setWejscieIlosc: (pageState: IPageState, ilosc: number) =>
      ({ ...pageState, wejscieIlosc: ilosc }),
    selectRoom: (pageState: IPageState,
      newState: PanelState, roomId: string = '') =>
    ({
      ...pageState, state: newState,
      selectedRoom: roomId
    }),
    /*updateEntranceTypes : (pageState: IPageState, newAsortRows : EntranceType[]) => 
    {   
        return({...pageState, entranceTypes: newAsortRows })
    },*/
    updateSold: (pageState: IPageState, newSold: number) => {
      return ({ ...pageState, sold: newSold })
    },
    updateFreePlaces: (pageState: IPageState, newFreePlaces: number) => {
      return ({ ...pageState, freePlaces: newFreePlaces })
    },
    updateControl: (pageState: IPageState, newControl: number) => {
      return ({ ...pageState, control: newControl })
    },
    updateEntered: (pageState: IPageState, newEntered: number) => {
      return ({ ...pageState, entered: newEntered })
    },

    /*
        newReservation : (pageState: IPageState, 
                      newState : PanelState, res  : Reservation) => 
                      { 
                        let newList = pageState.reservations
                        newList.push(res)
                        let newBasket = pageState.basket
                        newBasket.push({
                            id: res.id,
                            name: res.info, 
                            price: res.price,
                            quantity: 1        
                        })
                        return ({...pageState, state: newState,
                          reservations : newList,
                          basket: newBasket
                        })
                      },
                      */
    updateBasket: (pageState: IPageState, newBasket: AsortGrupyWiersz[]) => //ResBasket
      ({ ...pageState, basket: newBasket }),
    cpyToCart: (pageState: IPageState, bCpyToCart: boolean) =>
      ({ ...pageState, bCpyToCart}),
    setLang: (pageState: IPageState, lang: string) => {
      i18n.changeLanguage(lang)
      //          alert(pageState.lang+'->'+i18n.language)
      //          alert(JSON.stringify(i18n.languages))
      return ({ ...pageState, lang: lang })
    },
    setNormalTicketQuantity: (pageState: IPageState, quantity: number) =>
      ({ ...pageState, normalTicketsQuantity: quantity }),
    setMassageTicketQuantity: (pageState: IPageState, quantity: number) =>
      ({ ...pageState, massageTicketsQuantity: quantity }),
    setNightTicketQuantity: (pageState: IPageState, quantity: number) =>
      ({ ...pageState, nightTicketsQuantity: quantity }),
    setGiftQuantity: (pageState: IPageState, quantity: number) =>
      ({ ...pageState, giftQuantity: quantity }),
    setKeepersQuantity: (pageState: IPageState, quantity: number) =>
      ({ ...pageState, keepersQuantity: quantity }),
    setInitialValues: (pageState: IPageState, values: Values) =>
      ({ ...pageState, initialValues: values }),
    resetInitialValues: (pageState: IPageState) =>
      ({ ...pageState, initialValues: { phone: 0, address: '', NIP: '', Date: '', email: '' } }),
    setRememberValues: (pageState: IPageState, rememberValues: boolean) =>
      ({ ...pageState, rememberValues: rememberValues }),
    setReservationId: (pageState: IPageState, id: number) =>
      ({ ...pageState, reservationId: id }),
    setPdfData: (pageState: IPageState, data: PDFData[]) =>
      ({ ...pageState, pdfData: data }),
    setDownloadedPdf: (pageState: IPageState, downloadedPdf: boolean) =>
      ({ ...pageState, downloadedPdf: downloadedPdf }),
    incSearchSessionCount: (pageState: IPageState, reset: boolean) =>
      ({ ...pageState, searchSessionCount: reset ? pageState.searchSessionCount - 1 : pageState.searchSessionCount + 1 }),
    incSearchCount: (pageState: IPageState) =>
      ({ ...pageState, searchCount: pageState.searchCount + 1 }),
    incEditCount: (pageState: IPageState) =>
      ({ ...pageState, editCount: pageState.editCount + 1 }),
    incDownloadCount: (pageState: IPageState) =>
      ({ ...pageState, downloadCount: pageState.downloadCount + 1 }),
    incCancelCount: (pageState: IPageState) =>
      ({ ...pageState, cancelCount: pageState.cancelCount + 1 }),
    //setDisplay: (pageState: IPageState, newdisp: number) =>
    //  ({ ...pageState, display: newdisp }),
    setDisplayRight: (pageState: IPageState) =>
      ({ ...pageState, displayRight: pageState.displayRight + 1 }),
    setKarnetNumber: (pageState: IPageState, num: number) =>
      ({ ...pageState, karnetNumber: num }),
    incPassFailureCount: (pageState: IPageState) =>
      ({ ...pageState, passFailureCount: pageState.passFailureCount + 1 }),
    incAcceptCount: (pageState: IPageState, reset: boolean) =>
      ({ ...pageState, acceptCount: reset ? pageState.acceptCount - 1 : pageState.acceptCount + 1 }),
    setSelectedReport: (pageState: IPageState, report: string) =>
      ({ ...pageState, selectedReport: report }),
    getMenuItems: (pageState: IPageState, items: AsortWWWMenuNagl[]) =>
      ({ ...pageState, menuItems: items, selectedMenuItem: items[0].menu_id }),
    getAsortHeaders: (pageState: IPageState, items: AsortMenuWiersz[]) =>
      ({ ...pageState, asortHeaders: items }),
    getAsort: (pageState: IPageState, items: AsortGrupyWiersz[]) =>
      ({ ...pageState, asort: [...pageState.asort, items] }),
    selectMenuItem: (pageState: IPageState, id: number) =>
      ({ ...pageState, selectedMenuItem: id, refresh: pageState.refresh + 1 }),
    getInfo: (pageState: IPageState, data: WWWSprzedazInfo & { ip: string }) =>
      ({ ...pageState, info: data }),
    setMinItems: (pageState: IPageState, n: number) =>
      ({ ...pageState, minItems: n }),
    openDialogEnd: (pageState: IPageState) =>
      ({ ...pageState, dialogEnd: pageState.dialogEnd + 1 }),
    openDialogSms: (pageState: IPageState) =>
      ({ ...pageState, dialogSms: pageState.dialogSms + 1 }),
    setKontakt: (pageState: IPageState, nowyKontakt: Kontakt1[]) =>
      ({ ...pageState, kontakt: nowyKontakt }),
    setPaymentMethod: (pageState: IPageState, method: number) =>
      ({ ...pageState, paymentMethod: method }),
    setFonts: (pageState: IPageState, fonts: Font[]) =>
      ({ ...pageState, fonts: fonts }),
    setPanelStateAndResetBasket: (pageState: IPageState, newState: PanelState) =>
      ({ ...pageState, state: newState, basket: [] }),
    addFcmLogMessage: (pageState: IPageState, text: string, type: number) => {
      let log = pageState.fcmLogMessage
      log.push({ text: text, type: type })
      if (log.length >= 5 || type === 2) {
        sendFcmErrorLog(log)
        return ({ ...pageState, fcmLogMessage: [] })
      }
      return ({ ...pageState, fcmLogMessage: log })
    },  
    setDisplayMenu: (pageState: IPageState, newdisp: number) =>
      ({ ...pageState, displayMenu: newdisp }),
    setUserDataFromLocalStorage: (pageState: IPageState, userData: UserData) =>
      ({ ...pageState, userData: userData }),
    setDostawaDataDzien: (pageState: IPageState, dostawaDataDzien: string) =>
      ({ ...pageState, dostawaDataDzien: dostawaDataDzien }),
    setMap: (pageState: IPageState, data: MapData, reset: boolean = false) => {
      let prevMap = pageState.map
      let d = new MapData({
        obiektGPS: data.obiektGPS || prevMap.obiektGPS,
        obiektLat: data.obiektLat || prevMap.obiektLat,
        obiektLng: data.obiektLng || prevMap.obiektLng,
        klientAdres: data.klientAdres || prevMap.klientAdres,
        distance: data.distance || prevMap.distance,
        klientGPS: data.klientGPS || prevMap.klientGPS,
        klientLat: data.klientLat || prevMap.klientLat,
        klientLng: data.klientLng || prevMap.klientLng,
        dokNr: data.dokNr || prevMap.dokNr,
      })

      if (reset) {
        d = new MapData({
          obiektGPS: data.obiektGPS === undefined ? prevMap.obiektGPS : data.obiektGPS,
          obiektLat: data.obiektLat === undefined ? prevMap.obiektLat : data.obiektLat,
          obiektLng: data.obiektLng === undefined ? prevMap.obiektLng : data.obiektLng,
          klientAdres: data.klientAdres === undefined ? prevMap.klientAdres : data.klientAdres,
          distance: data.distance === undefined ? prevMap.distance : data.distance,
          klientGPS: data.klientGPS === undefined ? prevMap.klientGPS : data.klientGPS,
          klientLat: data.klientLat === undefined ? prevMap.klientLat : data.klientLat,
          klientLng: data.klientLng === undefined ? prevMap.klientLng : data.klientLng,
          dokNr: data.dokNr === undefined ? prevMap.dokNr : data.dokNr,
        })
      }

      return ({ ...pageState, map: d })
    },
    setCzarnaLista: (pageState: IPageState, lista: any[]) =>
       ({ ...pageState, czarnaLista: lista }),
    setPrefiksyPl: (pageState: IPageState, lista: PrefiksPl[]) =>
       ({ ...pageState, prefiksyPl: lista }),
    setPriorytet: (pageState: IPageState, p: number = 1, min: number = pageState.priorytetMin, max: number = pageState.priorytetMax) =>
       ({ ...pageState, priorytet: p, priorytetMin: min, priorytetMax: max }),
    setAsortymentowWGrupie: (pageState: IPageState, n: number = 1) =>
       ({ ...pageState, asortymentowWGrupie: n === 0 ? 0 : pageState.asortymentowWGrupie + n }),
       resetBoldy: (pageState: IPageState, ) =>
       ({ ...pageState, resetBoldy: pageState.resetBoldy + 1 }),
  });
/*
const pageStates = list({ of: pageState, key: pageState  => pageState.id}).addReducers({
    add: (pageStates: PageState[], pageState: PageState) => [...pageStates, pageState]
});
*/

const auth = definition<string | undefined>().
  setDefault(window.localStorage.getItem('accessToken') || undefined).
  use(setValueReducer).addActionCreators({
    login: function (accessToken: string) {
      window.localStorage.setItem('accessToken', accessToken);
      return this.setValue(accessToken);
    },
    logout: function () {
      window.localStorage.removeItem('accessToken');
      return this.setValue(undefined)
    }
  });


const appState = combine({
  auth,
  pageState
});

const { Actions, reduce } = create(appState);
export type AppState = StateOf<typeof appState>;

export const store: Store<AppState> = createStore(reduce,
  applyMiddleware(thunk, logger),
);

export { Actions, PanelState };
